/**
 * Builds the link a personal QR encodes. Indifferent to whether `token` is a
 * full `<ref>.<ent>.<exp>.<sig>` mint or a bare `ref` — the offline fallback
 * in `usePersonalQr` passes just the ref and must resolve to the same shape,
 * since event check-in reads only `ref` regardless of which one it scans.
 */
export const personalQrUrl = (origin: string, token: string): string => `${origin}/q/${token}`;
